// Homepage introduction band for WOW Journey.
// Placement: immediately after the hero <section>, before "Explore Romania".
// Kept intentionally compact so it does not compete with the existing editorial design.
import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLocale } from "../i18n";
import { WJ } from "../pages/wow-journey/i18n";
import { FEATURE_ENABLED } from "../lib/wowJourneyApi";

export default function WowJourneyBand() {
  const { locale } = useLocale();
  if (!FEATURE_ENABLED) return null;

  return (
    <section
      className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20 border-b border-[var(--wr-border)]"
      data-testid="wow-journey-band"
      aria-labelledby="wow-journey-band-heading"
    >
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <p className="font-mono-wr text-[11px] uppercase tracking-[0.3em] text-[var(--wr-ink-2)] mb-5">
            / {locale === "ro" ? "NOU" : "NEW"}
          </p>
          {/* Tricolor name: blue, gold, red — left to right, with a sharp readable gold */}
          <div className="font-editorial text-[42px] sm:text-[56px] lg:text-[68px] leading-[0.98] tracking-tight mb-6 select-none" data-testid="wow-journey-band-name">
            <span className="inline-flex items-baseline gap-[0.18em]">
              <span style={{ color: "#002B7F" }} aria-hidden="true">WOW</span>
              <span className="font-editorial italic" style={{ color: "#B8860B" }} aria-hidden="true">Journey</span>
            </span>
            <span className="block mt-1" style={{
              height: "4px",
              width: "180px",
              backgroundImage: "linear-gradient(to right, #002B7F 0 33%, #FCD116 33% 66%, #CE1126 66%)",
            }} aria-hidden="true" />
            <span className="sr-only">WOW Journey</span>
          </div>
          <h2
            id="wow-journey-band-heading"
            className="font-editorial text-[28px] sm:text-[34px] lg:text-[42px] leading-[1.05] tracking-tight text-[var(--wr-ink)] mb-5 max-w-2xl"
          >
            {locale === "ro" ? WJ.band.headline_ro : WJ.band.headline_en}
          </h2>
          <p className="text-[16px] sm:text-[17px] leading-relaxed text-[var(--wr-ink-2)] max-w-xl">
            {locale === "ro" ? WJ.band.desc_ro : WJ.band.desc_en}
          </p>
        </div>
        <div className="lg:col-span-4 flex lg:justify-end">
          <Link
            to="/plan"
            data-testid="wow-journey-band-cta"
            className="group inline-flex items-center justify-center gap-3 w-full lg:w-auto px-7 py-5 bg-[var(--wr-red)] text-white hover:bg-[var(--wr-red-hover)] transition-colors duration-300 rounded-sm"
          >
            <span className="font-mono-wr text-[12px] uppercase tracking-[0.2em]">
              {locale === "ro" ? "Creează-mi itinerariul" : "Plan my trip"}
            </span>
            <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
